import { required } from "utils/validations.utils";
import { create, test, enforce } from "vest";
import { EmailFormValues } from "./email-form.component";
import { getNormalizedEmails } from "./email.utils";
import { Recipient } from "./recipients-field.component";

export type FieldNames = "recipients" | "subject" | "content";
const templateStringRegex = /\{\{.*?\}\}/;

export const emailFormValidator = () =>
  create((data: EmailFormValues) => {
    const { recipients, subject, content } = data;

    required<FieldNames>("subject", "Subject", subject);
    required<FieldNames>("recipients", "To", recipients);

    required<FieldNames>("content", "Content", content);
    test("content", "Content must not include template strings", () => {
      enforce(content).notMatches(templateStringRegex);
    });

    test("recipients", "To is not valid", () => {
      enforce(recipients).condition((value) => {
        const validEmailsCount = getNormalizedEmails(value).length;
        const emailsCount = value
          .map((recipient: string | Recipient) =>
            typeof recipient === "string"
              ? recipient.trim()
              : recipient.email.trim()
          )
          .filter(Boolean).length;
        return {
          pass:
            value.length === 0 ||
            (validEmailsCount > 0 && emailsCount === validEmailsCount),
        };
      });
    });
  });
